<section class="text-center py-16">
  <div class="flex items-center justify-center w-full px-6 md:px-16 pt-10">
    <!-- TEXT -->
    <div class="text-center space-y-3">
      <h3 class="text-(--color-main) text-4xl font-bold">تعاقد بثقة معنا في القطاع الزراعي</h3>
      <p class="text-(--color-main) md:text-2xl leading-7 font-semibold">
        منصة AWALN توفر لك فرصًا تعاقدية مدروسة في مشاريع زراعية حقيقية، بعوائد سنوية متوقعة تصل إلى
        76%، وشفافية كاملة في كل خطوة.
      </p>

      <p class="text-white leading-7 md:text-xl">
        نحن في أولاً (AWALN) نُعيد تعريف العلاقة بين المتعاقد والقطاع الزراعي. ادخل عالم المشاريع
        الزراعية الحقيقية بأمان وبشروط واضحة، واختر فرصتك التعاقدية من بين عشرات المشاريع المُدققة،
        وتابع تطورها لحظة بلحظة من خلال تطبيق واحد.
      </p>
    </div>
  </div>

  <div class="pt-8">
    <!-- BUTTONS -->
    <button
      (click)="flow.openStart()"
      class="text-(--color-main) bg-(--color-secondary) px-12 h-12 rounded-3xl font-bold inline-flex items-center gap-2 cursor-pointer border-2 border-(--color-main) hover:bg-(--color-main-20) hover:text(--color-main) transition-all duration-300"
    >
      ابدأ التعاقد الآن
    </button>
  </div>
</section>
